<template>
 <div>
    <div class="flex between weight pady5">
        <p>拍卖榜</p>
        <p v-if="show_list.length>0">出价{{count}}次</p>
    </div>
    <div v-if="show_list.length>0">
        <div v-for="item,index in show_list" :key="index">
            <div class="bid flex between">
                <p :class="{ 'active' : index == 0}">{{ index +1 }}</p>
                <p class="nickname" :class="{ 'active' : index == 0}">{{ nicknameFormat(item.nickname) }}</p>
                <div class="flex" :class="{ 'active' : index == 0}">￥
                    <img v-if="item.auction_type == 2 && index == 0 && item.is_finish == 0" src="@/assets/img/hiddden.png" alt=""> 
                    <img v-else-if="item.auction_type == 2 && item.is_finish == 0" src="@/assets/img/hidden1.png" alt="">
                    <span v-else-if="item.auction_type == 2 && item.is_finish == 1">{{ item.bid_price }}</span>
                    <span v-else>{{ item.bid_price }}</span>
                </div>
                <div class="bid_time" v-if="status" :class="{ 'active' : index == 0}">{{ item.show_time }}</div>
                <div class="bid_time" v-else :class="{ 'active' : index == 0}">{{ item.end_time }}</div>

            </div>
        </div>
    </div>
    <div v-else class="weight center">暂无人出价</div>
    
    <div class="center weight pady5" @click="openDetail" v-if="show_list.length>0">查看详情</div>
 </div>
 <!-- 查看出价版详情 -->
     <van-popup z-index="999999" v-model:show="showPopup" style="min-height:50%;max-height:70%;width:90%" >
        <div class="flex between pad10 ">
            <p></p>
            <div class="size18 bold">竞拍榜单</div>
            <van-icon @click="showPopup = false" name="cross" size="22" />
        </div>
        <van-list v-model:loading="loading" :finished="finished" @load="onLoad">
            <div class="pad10">
                <!-- <div class="flex between weight pady5">
                <p>拍卖榜</p>
                <p v-if="show_list.length>0">出价{{count}}次</p>
            </div> -->
            <div v-if="show_list.length>0">
                <div v-for="item,index in list" :key="index">
                    <div class="bid flex between">
                        <p :class="{ 'active' : index == 0}">{{ index +1 }}</p>
                        <p class="nickname" :class="{ 'active' : index == 0}">{{ nicknameFormat(item.nickname) }}</p>
                        <div class="flex" :class="{ 'active' : index == 0}">￥
                            <img v-if="item.auction_type == 2 && index == 0 && item.is_finish == 0" src="@/assets/img/hiddden.png" alt=""> 
                            <img v-else-if="item.auction_type == 2 && item.is_finish == 0" src="@/assets/img/hidden1.png" alt="">
                            <span v-else-if="item.auction_type == 2 && item.is_finish == 1">{{ item.bid_price }}</span>
                            <span v-else>{{ item.bid_price }}</span>
                        </div>
                        <div class="bid_time" v-if="status" :class="{ 'active' : index == 0}">{{ item.show_time }}</div>
                        <div class="bid_time" v-else :class="{ 'active' : index == 0}">{{ item.end_time }}</div>

                    </div>
                </div>
            </div>
            <div v-else class="weight center">暂无人出价</div>
            
            </div>
            <template #finished>{{ finishtxt }}</template>
        </van-list>
        
     </van-popup>

</template>
<script>
import ajax from "@/utils/request.js";
// import { showToast, showConfirmDialog } from "vant";
export default {
  data () {
    return {
        list:[],//全部列表
        show_list:[],//展示列表
        count:0,// 出价总数
        showPopup:false,
        loading: false, 
        finished: false, 
        page:1,
        initialData:false,// 避免page为1时重复请求
    }
  },
  props: {
    goods_id: {
      type: Number
    },
    // 拍卖状态  1： 拍卖中   0：已结束
    status:{
        type:Number,
        default:1
    },
    bid_status:{
      type:Number,
      default:0
    },
  },
  created(){
    this.init()
  },
  watch:{
    goods_id:function(newVal){
      if(newVal){
        this.show_list = []
        this.list= []
        this.page= 1
        this.finished = false
        this.loading = false
        this.initialData = false
        this.init()
      }
    },
    bid_status:function(newVal){
      if(newVal){
        this.show_list = []
        this.list= []
        this.page= 1
        this.finished = false
        this.loading = false
        this.initialData = false
        this.init()
      }
    },
  },
   methods:{
    init(){
        ajax.post("products/getbidlist",{goods_id:this.goods_id,page:this.page}).then(res=>{
            this.count = res.count
            res.data.forEach((item,index)=> {
                if(index<3){
                    this.show_list.push(item)
                }
            });
        })
    },
    nicknameFormat(nickname){
        if(nickname.length == 2){
            return nickname.substring(0,1) + '*';
        }else if (nickname.length > 2){
            return nickname.substring(0,1) + '*' + nickname.substring(nickname.length - 1);
        }
        return nickname;
    },
    openDetail(){
        this.getList()
        this.showPopup = true
    },
    getList(){
        if(this.page === 1 && this.initialData){
            this.page = 2
        }
        if(this.page === 1){
            this.initialData = true
        }
        let data = {
            page : this.page,
            goods_id :this.goods_id
        }
        ajax.post("products/getbidlist",data) .then((res) => {
          if (res.data.length < 10) {
            this.finishtxt = "";
            this.finished = true;
            this.list = this.list.concat(res.data);
            setTimeout(() => {
              this.finishtxt = "没有更多了";
            }, 1000);
          } else {
            this.finishtxt = "";
            this.list = this.list.concat(res.data);
            this.page++;
          }
        })
        .finally(() => {
          this.loading = false;
        })
        .catch(() => {
          this.finished = true;
        });

    },
    onLoad () {
      this.getList();
    },
   }
 
}
</script>
<style scoped lang="scss">
.bid{
    padding: 5px  0;
    border-bottom: 1px solid #f7f7f7;
    &:first-child{
        border-top: 1px solid #f7f7f7;
    }
    p{
        width: 15%;
        margin-right: 3%;
        color: #888;
        &:first-child{
            font-weight: bold;
            color: #000;
        }
    }
    img{
        width: 5vw;
    }
    .bid_time{
        display: flex;
        flex: 1;
        justify-content: flex-end;
        color: #888;

    }
    .nickname{

    }
    .active{
        font-weight: bold;
        color: #000;
    }
}

</style>